import { Component, OnInit, OnDestroy, Input, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { ConfigService, RiderService, AppDataService } from 'app/services';
import { MessageService, LazyLoadEvent, MenuItem } from 'primeng/api';
import {
    VehicleStatusEnum,
    RiderVehicleTypeEnum,
    RiderVehicleType,
    TimeFilterTitleEnum,
    TimeFilterValueEnum, LastActiveTypeModel,
    MenuPermissionConfig, MenuPermissionActionEnum, FieldTypeEnum,
    WheelTypeEnum
} from 'app/models';
import { Utils } from 'app/utils';
import * as moment from 'moment';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';
import { Subscription } from 'rxjs';

@Component({
    selector: 'onboarding-vehicles',
    templateUrl: './onboarding-vehicles.component.html',
    styleUrls: ['./onboarding-vehicles.component.scss',
        '../../../../../styles/paginator.scss'],
    providers: [MessageService]
})
export class OnboardingVehiclesComponent implements OnInit, OnDestroy, OnChanges {
    @Input()
    public menuPermissionActive!: string;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    public lastActiveTypeList = LastActiveTypeModel.LastActiveTypeList;
    // Grid settings
    public rowsPerPage: number = 15;
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public gridRiders: RidersOnboarding = new RidersOnboarding();
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_back_office' }, { label: 'Application' }];

    public tabMenu: any = [ ];

    constructor(private messageService: MessageService,
        private riderService: RiderService, public configService: ConfigService,
        public appData: AppDataService)
    {
        this.riderVehicleType = RiderVehicleType.RiderVehicleTypeList;
    }

    public riderVehicleTypeEnum = RiderVehicleTypeEnum;
    public activeRiderVehicleTypeEnum!: RiderVehicleTypeEnum;

    public riderVehicleServiceTypeId!: number;
    public riderVehicleId!: number;
    public riderId!: number;
    public visibleSidebarRiderVehicleDetail: boolean = false;

    public fieldTypeEnum = FieldTypeEnum;
    public wheelsEnum = WheelTypeEnum;
    public activeMenu: WheelTypeEnum = WheelTypeEnum.TwoWheels;

    private searchTimer: number = 0;
    public riderHeaderSearch: any = {
        vehicleId: null,
        vehicleTypeId: null,
        serviceTypeId: null,
        status: null,
        vehicleModel: null,
        riderServiceAndVehicle: null,
        lastUpdate: null,
        createdAtDate: null,
        franchiseNumber: null,
        lastActiveTypeObj: null,
        updatedBy: null,
        driverName: null
    };
    public riderOnboardingDate!: Date;
    public riderVehicleType!: RiderVehicleType[];
    public arrayFilterStatuses: any = [
        { name: 'New', value: VehicleStatusEnum.New },
        { name: 'Rejected', value: VehicleStatusEnum.New },
        { name: 'Approved', value: VehicleStatusEnum.Approved },
        { name: 'Vehicle Details', value: VehicleStatusEnum.CheckingVehicleDetails },
        { name: 'Vehicle OR/CR', value: VehicleStatusEnum.CheckingOrCr },
        { name: 'Vehicle SPA/AL', value: VehicleStatusEnum.CheckingSpaAl },
        { name: 'TNVS - PA/TAS/CPC', value: VehicleStatusEnum.CheckingPaCpcTas },
        { name: 'TNVS - PAMI', value: VehicleStatusEnum.CheckingPami },
        { name: 'TNVS - Comprehensive Insurance', value: VehicleStatusEnum.CheckingCI },
    ];

    public arrayFilterRiderServiceAndVehicle: any = [];
    public arrayFilterRegions: any = [];
    public arrayFilterVehicleModels: any = [];
    public arrayFilterLastUpdateValues: any = [];

    public cols: any[] = [
        {
            field: 'Status', header: 'Status', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown,
            model: 'status', options: this.arrayFilterStatuses, placeholder: 'Please Select'
        },
        {
            field: 'UserName', header: 'Driver Name', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Inputs,
            model: 'driverName', placeholder: 'Type here'
        },
        {
            field: 'RiderServiceAndVehicle', header: 'Service Type', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown,
            model: 'riderServiceAndVehicle', options: this.arrayFilterRiderServiceAndVehicle, placeholder: 'Please Select'
        },
        {
            field: 'ApplicationDateTime', header: 'Application Date & Time', width: '20%', disableSort: false,
            fieldType: FieldTypeEnum.Calendar, model: 'createdAtDate', placeholder: 'Date & Time'
        },
        {
            field: 'Region', header: 'Region', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Dropdown,
            model: 'region', options: this.arrayFilterRegions, placeholder: 'Please Select'
        },
        {
            field: 'LastUpdate', header: 'Last Update', width: '20%', disableSort: false, model: 'lastActiveType',
            options: this.arrayFilterLastUpdateValues, placeholder: 'Please Select'
        },
        {
            field: 'UserNameUpdatedBy', header: 'Updated By', width: '20%', disableSort: false, fieldType: FieldTypeEnum.Inputs,
            model: 'updatedBy', placeholder: 'Type here'
        },
    ];
    public defaultCols = this.cols.map(x => x);

    clientLocationTypeSubscription: Subscription | undefined;

    ngOnInit(): void {
        this.updateBreadcrumbs();
        this.getTabMenu();

        this.clientLocationTypeSubscription = this.appData.clientLocationType$.subscribe(locationType => {
            this.updateBreadcrumbs();
            this.getTabMenu();
            this.callRidersVehicleOnboarding(0);
        });
    }

    ngOnDestroy() {
        if (this.clientLocationTypeSubscription) {
            this.clientLocationTypeSubscription.unsubscribe();
        }
    }

    private getTabMenu() {
        this.tabMenu = [];
        if (this.appData.isBoracayLocation) {
            this.activeMenu = WheelTypeEnum.ThreeWheels;

            this.tabMenu.push({
                name: '3 Wheels',
                value: WheelTypeEnum.ThreeWheels
            });
            this.tabMenu.push({
                name: '4 Wheels',
                value: WheelTypeEnum.FourWheels
            });
        } else {
            this.activeMenu = WheelTypeEnum.TwoWheels;

            this.tabMenu.push({
                name: '2 Wheels',
                value: WheelTypeEnum.TwoWheels
            });
            this.tabMenu.push({
                name: '4 Wheels',
                value: WheelTypeEnum.FourWheels
            });
        }
        console.log(this.tabMenu);
    }

    public updateBreadcrumbs() {
        this.breadcrumbs = [{ icon: 'icon_back_office' }, { label: 'Application' }];
        if (!this.appData.isBoracayLocation) {
            this.breadcrumbs.push({ label: 'Vehicles' });
        } else {
            if (this.menuPermissionActive === MenuPermissionConfig.BACK_OFFICE_OPERATORS_OPERATORS ||
                this.menuPermissionActive !== MenuPermissionConfig.BACK_OFFICE_VEHICLES) {
                this.breadcrumbs.push({ label: 'Operators' });
            }
            if (this.menuPermissionActive === MenuPermissionConfig.BACK_OFFICE_OPERATORS_VEHICLES ||
                this.menuPermissionActive === MenuPermissionConfig.BACK_OFFICE_VEHICLES) {
                this.breadcrumbs.push({ label: 'Vehicles' });
            }
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.updateBreadcrumbs();
    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.menuPermissionActive);
        }

        this.callVehiclePageTitles(skip);
    }

    onSelectedColumnsChange(event: any) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }

    public changeActiveMenu(value: WheelTypeEnum) {
        this.activeMenu = value;
        this.callRidersVehicleOnboarding(0);
    }

    callVehiclePageTitles(skip: number) {
        if (!this.arrayFilterLastUpdateValues.length) {
            this.addLastUpdateFilterValues();
        }
        this.callRidersVehicleOnboarding(skip);
    }

    public callRidersVehicleOnboarding(skip: number) {
        this.gridRiders = new RidersOnboarding();
        this.gerRidersVehicleOnboarding({
            VehicleStatusId: this.riderHeaderSearch.status,
            VehicleId: (!this.riderHeaderSearch.vehicleId) ? '' : this.riderHeaderSearch.vehicleId,
            VehicleTypeId: (!this.riderHeaderSearch.riderServiceAndVehicle?.name) ? null : this.riderHeaderSearch.riderServiceAndVehicle.name,
            ServiceTypeId: (!this.riderHeaderSearch.riderServiceAndVehicle?.value) ? null : this.riderHeaderSearch.riderServiceAndVehicle.value,
            OnboardingDateTime: this.riderHeaderSearch.createdAtDate ? this.riderHeaderSearch.createdAtDate : null,
            Region: (!this.riderHeaderSearch.region) ? '' : this.riderHeaderSearch.region,
            LastUpdate: (!this.riderHeaderSearch.lastUpdate) ? '' : this.riderHeaderSearch.lastUpdate.toString(),
            VehicleBrand: (!this.riderHeaderSearch.vehicleModel) ? '' : this.riderHeaderSearch.vehicleModel,
            UserNameUpdatedBy:  (!this.riderHeaderSearch.updatedBy) ? '' : this.riderHeaderSearch.updatedBy,
            DriverName: (!this.riderHeaderSearch.driverName) ? '' : this.riderHeaderSearch.driverName,
            FranchiseNumber: this.riderHeaderSearch.franchiseNumber ? this.riderHeaderSearch.franchiseNumber : null,
            LastActiveType: (this.riderHeaderSearch.lastActiveTypeObj) ? this.riderHeaderSearch.lastActiveTypeObj.value : null,
            LastActiveAt: (this.riderHeaderSearch.lastActiveTypeObj && this.riderHeaderSearch.lastActiveTypeObj.dateTime) ?
                moment(this.riderHeaderSearch.lastActiveTypeObj.dateTime).format('YYYY-MM-DDTHH:mm:ss') : null,
            VehicleTypes: this.getVehicleTypeListByWheelTypeActive(),
            TimeZoneOffset: Utils.getTimezoneOffset(),
            Skip: skip,
            Take: this.gridRiders.Take,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        }, this.gridRiders, 'Additional Vehicle');
    }

    public gerRidersVehicleOnboarding(dto: any, ridersOnboarding: RidersOnboarding, status: string) {
        ridersOnboarding.Loading = true;
        this.riderService.getVehicleRidersOnboarding(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    ridersOnboarding.Loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.totalRecords = data.TotalRecords;
                ridersOnboarding.Items.push(...data.Items);
                ridersOnboarding.Items.forEach(item => {
                    item.ApplicationDateTime = moment(item.CreatedAt).format('DD MMM YYYY | hh:mmA');
                    item.CreatedAtDate = moment(Utils.utcToLocalDate(item.CreatedAt), 'MMDDYYYY')
                        .format('DD MMM YYYY');

                    item.XpressRiderFranchiseNumber = (item.XpressRiderFranchiseNumber)
                        ? 'E-MLY ' + item.XpressRiderFranchiseNumber : '';

                    if (item.VehicleStatusId === VehicleStatusEnum.New) {
                        item.Status = 'New';
                        item.StatusColor = '#0A84FF';
                    }
                    else if (item.VehicleStatusId === VehicleStatusEnum.Rejected) {
                        item.Status = 'Rejected';
                        item.StatusColor = '#EB4236';
                    }
                    else if (item.VehicleStatusId === VehicleStatusEnum.Approved) {
                        item.Status = 'Approved';
                        item.StatusColor = '#1CBA70';
                    }
                    else if (item.VehicleStatusId === VehicleStatusEnum.CheckingVehicleDetails) {
                        item.Status = 'Vehicle Details';
                        item.StatusColor = '#F77F00';
                    }
                    else if (item.VehicleStatusId === VehicleStatusEnum.CheckingOrCr) {
                        item.Status = 'Vehicle OR/CR';
                        item.StatusColor = '#F77F00';
                    }
                    else if (item.VehicleStatusId === VehicleStatusEnum.CheckingSpaAl) {
                        item.Status = 'Vehicle SPA/AL';
                        item.StatusColor = '#F77F00';
                    }
                    else if (item.VehicleStatusId === VehicleStatusEnum.CheckingPaCpcTas) {
                        item.Status = 'TNVS - PA/TAS/CPC';
                        item.StatusColor = '#FDD76A';
                    }
                    else if (item.VehicleStatusId === VehicleStatusEnum.CheckingPami) {
                        item.Status = 'TNVS - PAMI';
                        item.StatusColor = '#FDD76A';
                    }
                    else if (item.VehicleStatusId === VehicleStatusEnum.CheckingCI) {
                        item.Status = 'TNVS - Comprehensive Insurance';
                        item.StatusColor = '#FDD76A';
                    }
                    else {
                        item.Status = '';
                    }

                    const lastUpdateDate = new Date(item.UpdatedAt);
                    const currentDate = new Date();
                    const diffInMonths =
                        (currentDate.getFullYear() - lastUpdateDate.getFullYear()) * 12 +
                        (currentDate.getMonth() - lastUpdateDate.getMonth());
                    if (diffInMonths >= 3) {
                        item.LastActiveAtTextColor = '#FFB100';
                    }

                    this.mergeVehicleModelsDuplicates(item.VehicleBrand, item.VehicleBrand, item.VehicleMake);
                    this.mergeRegionDuplicates(item.Region, item.Region);
                });

                ridersOnboarding.Loading = false;
            })
            .catch(err => {
                ridersOnboarding.Loading = false;
                throw err;
            });

        this.mergeVehicleModelsDuplicates('All', 0);
        this.mergeRegionDuplicates('All', 0);
    }

    public mergeVehicleModelsDuplicates(name: string, value: any, field: any = 0) {
        if (field === ''){
            return;
        }
        const exists = this.arrayFilterVehicleModels.some((obj: any) => obj.name === name);
        if (!exists) {
            this.arrayFilterVehicleModels.push({
                name,
                value
            });
        }
    }

    public mergeRegionDuplicates(name: string, value: any) {
        if (!name || name === ''){
            return;
        }
        const exists = this.arrayFilterRegions.some((obj: any) => obj.name === name);
        if (!exists) {
            this.arrayFilterRegions.push({
                name,
                value
            });
        }
    }

    public handleHeaderFilterChange(model: string, event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }
        this.searchTimer = window.setTimeout(() => {
            this.callVehiclePageTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public addLastUpdateFilterValues() {
        const arrayFilterLastUpdates = [
            { name: TimeFilterTitleEnum.All, value: TimeFilterValueEnum.All },
            { name: TimeFilterTitleEnum.OnlineNow, value: TimeFilterValueEnum.OnlineNow },
            { name: TimeFilterTitleEnum.LessThan30Mins, value: TimeFilterValueEnum.LessThan30Mins },
            { name: TimeFilterTitleEnum.LessThan1Hr, value: TimeFilterValueEnum.LessThan1Hr },
            { name: TimeFilterTitleEnum.LessThan8Hrs, value: TimeFilterValueEnum.LessThan8Hrs },
            { name: TimeFilterTitleEnum.LessThan24Hrs, value: TimeFilterValueEnum.LessThan24Hrs },
            { name: TimeFilterTitleEnum.LessThan72Hrs, value: TimeFilterValueEnum.LessThan72Hrs },
            { name: TimeFilterTitleEnum.LessThan120Hrs, value: TimeFilterValueEnum.LessThan120Hrs },
            { name: TimeFilterTitleEnum.LessThan168Hrs, value: TimeFilterValueEnum.LessThan168Hrs },
            { name: TimeFilterTitleEnum.MoreThan168Hrs, value: TimeFilterValueEnum.MoreThan168Hrs },
        ];
        this.arrayFilterLastUpdateValues.push(...arrayFilterLastUpdates);
    }


    public onChangeDateAndDropDown(event: any) {
        this.callVehiclePageTitles(0);
    }

    public onChangeHeaderFilterDropDown(model: string, event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            if (model === 'Status') {
                if (event === -1) {
                    this.riderHeaderSearch.status = null;
                }
            }
            if (model === 'ServiceTypeText') {
                if (event !== 0){
                    this.riderHeaderSearch.serviceTypeText = event;
                }
            }
            if (model === 'Region') {
                if (event !== 0){
                    this.riderHeaderSearch.region = event;
                }
            }
            this.callVehiclePageTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public openSidebarExistingVehicleDetail(item: any) {
        if (this.appData.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Create) ||
            this.appData.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Update)) {
            this.riderVehicleServiceTypeId = item.RiderVehicleServiceTypeId;
            this.riderVehicleId = item.RiderVehicleId;
            this.riderId = item.RiderId;
            this.showSidebarForCheckingVehicle(item.VehicleStatusId);
        }
        else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Access denied' });
        }
    }

    showSidebarForCheckingVehicle(vehicleStatus: VehicleStatusEnum) {
        switch (vehicleStatus) {
            case VehicleStatusEnum.New:
            case VehicleStatusEnum.CheckingVehicleDetails:
            case VehicleStatusEnum.CheckingOrCr:
            case VehicleStatusEnum.CheckingSpaAl:
            case VehicleStatusEnum.CheckingPaCpcTas:
            case VehicleStatusEnum.CheckingPami:
            case VehicleStatusEnum.CheckingCI:
                this.visibleSidebarRiderVehicleDetail = true;
                break;
            default:
                console.log('Unknow vehicle status');
                break;
        }
    }

    //public openSidebarVehicleRequirement() {
    //    this.visibleSidebarVehicleRequirement = true;
    //}

    //changedvisibleSidebarVehicleRequirementEmit(value: any) {
    //    this.visibleSidebarVehicleRequirement = value;
    //}

    //public openSidebarExistingTNCRequirement() {
    //    this.visibleSidebarExistingTNCRequirement = true;
    //}

    //changedVisibleSidebarExistingTNCRequirementEmit(value: any) {
    //    this.visibleSidebarExistingTNCRequirement = value;
    //}

    //public openSidebarPending(item: any) {
    //    this.riderVehicleServiceTypeId = item.RiderVehicleServiceTypeId;
    //    this.riderVehicleId = item.RiderVehicleId;
    //    this.riderId = item.RiderId;
    //    this.visibleSidebarPending = true;
    //}

    //changedVisibleSidebarPendingEmit(value: any) {
    //    this.visibleSidebarPending = value;
    //}

    public openSidebarExistingRiderVehicleDetail(item: any) {
        this.riderVehicleServiceTypeId = item.RiderVehicleServiceTypeId;
        this.riderVehicleId = item.RiderVehicleId;
        this.riderId = item.RiderId;
        this.visibleSidebarRiderVehicleDetail = true;
    }

    changedVisibleSidebarRiderVehicleDetailEmit(value: any) {
        this.visibleSidebarRiderVehicleDetail = value;
    }

    public clickOnboardingLink(menu: RiderVehicleTypeEnum) {
        this.activeRiderVehicleTypeEnum = menu;

        this.callRidersVehicleOnboarding(0);
    }

    private getVehicleTypeListByWheelTypeActive() {
        switch (this.activeMenu) {
            case WheelTypeEnum.TwoWheels:
                return [RiderVehicleTypeEnum.Moto];
            case WheelTypeEnum.ThreeWheels:
                return [RiderVehicleTypeEnum.ETrike];
            case WheelTypeEnum.FourWheels:
                return (this.appData.isBoracayLocation) ? [RiderVehicleTypeEnum.Grocery, RiderVehicleTypeEnum.Van,
                RiderVehicleTypeEnum.Minibus, RiderVehicleTypeEnum.Multicab]
                    : [RiderVehicleTypeEnum.Sedan, RiderVehicleTypeEnum.SUV];
            default: return null;
        }
    }

    protected readonly MenuPermissionConfig = MenuPermissionConfig;
}

class RidersOnboarding {
    public Loading: boolean = true;
    public TotalRecords: number = 0;
    public Items: Array<any> = [];
    public Skip: number = 0;
    public Take: number = 10;
    public VisibleBtnLoadMore: boolean = false;
}
